const GET_ASSET_OREDR_HEADER_DETAILS = 'GET_ASSET_OREDR_HEADER_DETAILS'
const SET_ASSET_OREDR_HEADER_DETAILS = 'SET_ASSET_OREDR_HEADER_DETAILS'

const GET_AFE_ORDER_HEADER_DETAILS = 'GET_AFE_ORDER_HEADER_DETAILS'
const SET_AFE_ORDER_HEADER_DETAILS = 'SET_AFE_ORDER_HEADER_DETAILS'

const GET_ASSET_FLEET_HEADER_DETAILS = 'GET_ASSET_FLEET_HEADER_DETAILS'
const SET_ASSET_FLEET_HEADER_DETAILS = 'SET_ASSET_FLEET_HEADER_DETAILS'

const GET_AFE_FLEET_HEADER_DETAILS = 'GET_AFE_FLEET_HEADER_DETAILS'
const SET_AFE_FLEET_HEADER_DETAILS = 'SET_AFE_FLEET_HEADER_DETAILS'

const GET_ASSET_FLEET_ITEM_DETAILS = 'GET_ASSET_FLEET_ITEM_DETAILS'
const SET_ASSET_FLEET_ITEM_DETAILS = 'SET_ASSET_FLEET_ITEM_DETAILS'

const GET_AFE_FLEET_ITEM_DETAILS = 'GET_AFE_FLEET_ITEM_DETAILS'
const SET_AFE_FLEET_ITEM_DETAILS = 'SET_AFE_FLEET_ITEM_DETAILS'

const GET_ASSET_FLEET_TASK_DETAILS = 'GET_ASSET_FLEET_TASK_DETAILS'
const SET_ASSET_FLEET_TASK_DETAILS = 'SET_ASSET_FLEET_TASK_DETAILS'

const GET_AFE_FLEET_TASK_DETAILS = 'GET_AFE_FLEET_TASK_DETAILS'
const SET_AFE_FLEET_TASK_DETAILS = 'SET_AFE_FLEET_TASK_DETAILS'

const SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM = 'SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM'
const SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM = 'SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM' 

const SET_ASSET_OPEN_ACCORDION_LIST = "SET_ASSET_OPEN_ACCORDION_LIST"

export {
    GET_ASSET_OREDR_HEADER_DETAILS,
    SET_ASSET_OREDR_HEADER_DETAILS,
    GET_AFE_ORDER_HEADER_DETAILS,
    SET_AFE_ORDER_HEADER_DETAILS,
    GET_ASSET_FLEET_HEADER_DETAILS,
    SET_ASSET_FLEET_HEADER_DETAILS,
    GET_AFE_FLEET_HEADER_DETAILS,
    SET_AFE_FLEET_HEADER_DETAILS,
    GET_ASSET_FLEET_ITEM_DETAILS,
    SET_ASSET_FLEET_ITEM_DETAILS,
    GET_AFE_FLEET_ITEM_DETAILS,
    SET_AFE_FLEET_ITEM_DETAILS,
    GET_ASSET_FLEET_TASK_DETAILS,
    SET_ASSET_FLEET_TASK_DETAILS,
    GET_AFE_FLEET_TASK_DETAILS,
    SET_AFE_FLEET_TASK_DETAILS,
    SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSET_OPEN_ACCORDION_LIST
}
